import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { MyTabsComponent } from '../../my-tabs/my-tabs.component';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { TemplateRefDiamondsService } from './diamonds-popup/template-ref-diamonds.service';
import { ModalService } from 'src/app/shareModule/services/modal.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { filter } from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { AppState } from 'src/app/shareModule/states/app.state';

@Component({
  selector: 'app-level-profile',
  templateUrl: './level-profile.component.html',
  styleUrls: ['./level-profile.component.scss'],
})
export class LevelProfileComponent implements OnInit {
  public tab: string = 'shop';
  public profileInfo: any = {
    favorites: []
  };
  public showVerification: boolean = false;
  public otpSent: boolean = false;
  public otp: string = '';
  public passcode: string = '';
  public isLoading: boolean = false;
  public otpError: string = '';
  public isReset: boolean = false;
  public diamonds: any = '0';
  public user: any;
  public telegramLink: string;
  public showOtherMenu: boolean = false;
  public profileImage: string = '';
  /**
   * Constructor
   */
  constructor(
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private http: HttpClient,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private templateRefDiamondsService: TemplateRefDiamondsService,
    private myModalService: ModalService,
    private customerService: CustomerService,
    public roleService: RoleService,
    private store: Store<AppState>,
  ) { }

  imgUrl: string = environment.ImageUrl

  ngOnInit(): void {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.user = user;
      }
    });

    this.store.pipe(select(selectUser)).pipe(filter(user => !!user)).subscribe((response: User) => {
      this.profileInfo = response || [];
      console.log(this.profileInfo, "PROFILE INFO")
      this._getFavoriteProductList();
      this.diamonds = response.diamonds || '0';
      if (this.profileInfo?.level > 0 && this.profileInfo?.level <= 3) {
        this.profileImage = `../../../../../../assets/images/level/level${this.profileInfo?.level}.png`;
      } else if (this.profileInfo?.level > 3) {
        this.profileImage = this.local.checkImageProfile(this.profileInfo);
      } else {
        this.profileImage = `../../../../../../assets/images/new/badge.png`;
      }
    });
  }


  private _getFavoriteProductList() {
    this.auth
      .marketplace_favorite_product_profile({
        isAdmin: this.local.getUser()?.role == 'admin',
      })
      .subscribe((response: any) => {
        this.profileInfo = {favorites:response.body, ...this.profileInfo};
      });
  }
  public maskNumber(number: any): string {
    return number ? number.toString().replace(/\d(?=\d{4})/g, '*') : '';
  }

  async verifyOtp() {
    try {
      const response = await fetch(
        environment.baseUrlAdmin + 'member_verify_otp_marketplace',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            phoneNumber: this.profileInfo?.phone,
            otp: this.otp,
            passcode: this.passcode,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Something went wrong');
      }

      const responseData = await response.json();


      const data = {
        messaging_product: 'whatsapp',
        recipient_type: 'individual',
        to: `${this.profileInfo.countryCode}${this.profileInfo.phone}`,
        type: 'template',
        template: {
          name: 'welcome_onboard_buttons2',
          language: {
            code: 'en',
          },
          components: [
            {
              type: 'header',
              parameters: [
                {
                  type: 'image',
                  image: {
                    link: 'https://firebasestorage.googleapis.com/v0/b/si-jaim.appspot.com/o/welcome.png?alt=media&token=47c25865-0518-42fc-bfdd-f03e0d49cdc0',
                  },
                },
              ],
            },
          ],
        },
      };

      const token = environment.whtsappCloudToken;
      if (!this.isReset) {
        const whatsappResponse = await fetch(environment.whtsappCloudUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        });

        if (!whatsappResponse.ok) {
          const errorData = await whatsappResponse.json();
          throw new Error(
            errorData.message || 'Failed to send WhatsApp message'
          );
        }
      }
      window.location.reload();
    } catch (err) {
      this.isLoading = false;
      this.isReset = false;

      console.error(err);
      this.otpError = err.message;
    }
  }


  openBuyDiamonds() {
    const signinPopup = this.templateRefDiamondsService.getDiamondsPopup();
    if (signinPopup) {
      this.myModalService.open(signinPopup, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'diamondsPopup',
      });
    }
  }


  sendVerificationEmail() {

    this.http.get(environment.baseUrlAdmin + 'sendVerificationEmail').subscribe((e: any) => {
      if (e.success) {
        this.toastr.success("Email sent!")
      }
    })
  }
  subscribeto(token, subc = 0, notification_code = 'DEFAULT') {
    let stripe_price_id = '';
    let tokens = 'diamond';
    let sub_type = "0";
    if (token == 1) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgRBHqb9USI';
      // stripe_price_id = 'price_1PXB9j03HSHmHwgRqY423W2q'; // test // 10
    } else if (token == 2) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgR4pUGQMcJ';
      // stripe_price_id = 'price_1PXBA703HSHmHwgRrGsz1caP'; // test // 50
    } else if (token == 3) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgRSrdF2phA';
      // stripe_price_id = 'price_1PXBAF03HSHmHwgRreL0wkSJ'; // test // 100
    }
  }

  GoToMyTabs(index: any) {
    this.sharedService.triggerSelectMyTab(index);
  }
}
